import { render, staticRenderFns } from "./SupervisionContractRecord.vue?vue&type=template&id=95d2246e&scoped=true"
import script from "./SupervisionContractRecord.vue?vue&type=script&lang=js"
export * from "./SupervisionContractRecord.vue?vue&type=script&lang=js"
import style0 from "./SupervisionContractRecord.vue?vue&type=style&index=0&id=95d2246e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d2246e",
  null
  
)

export default component.exports